import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Baby, Lock } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (password !== confirm) return setError("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata! Accedi con la nuova password.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF6F0] flex items-center justify-center px-4" data-testid="reset-password-page">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#E07A5F] flex items-center justify-center shadow-lg mb-3">
            <Baby className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-semibold text-[#3D405B]">Nuova password</h1>
        </div>
        <form onSubmit={submit} className="card-warm p-8 space-y-5" data-testid="reset-password-form">
          {!token && <p className="text-sm text-red-600" data-testid="reset-missing-token">Link non valido: token mancante.</p>}
          <div>
            <label className="label-warm block mb-2">Nuova password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#a89a8a]" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="reset-password-input" className="input-warm pl-11" placeholder="Minimo 8 caratteri" />
            </div>
          </div>
          <div>
            <label className="label-warm block mb-2">Conferma password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#a89a8a]" />
              <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                data-testid="reset-confirm-input" className="input-warm pl-11" placeholder="Ripeti la password" />
            </div>
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="btn-warm w-full">
            {loading ? "Salvataggio..." : "Reimposta password"}
          </button>
          <Link to="/login" data-testid="back-to-login-link" className="block text-center text-sm text-[#b0563a] hover:underline font-medium">
            Torna al login
          </Link>
        </form>
      </div>
    </div>
  );
}
